import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";

interface ReplacementValueDeleteDialogProps {
  open: boolean;
  value: {
    id: number;
    value: string;
  } | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ReplacementValueDeleteDialog = ({
  open,
  value,
  isDeleting,
  onCancel,
  onConfirm,
}: ReplacementValueDeleteDialogProps) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Delete Replacement Value</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this replacement value?
        </DialogContentText>
        {value && (
          <Box
            sx={{
              mt: 2,
              p: 1.5,
              bgcolor: "grey.100",
              borderRadius: 1,
            }}
          >
            <Typography variant="body2" fontWeight={600}>
              {value.value}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onCancel} variant="outlined" disabled={isDeleting}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={isDeleting}
        >
          {isDeleting ? <CircularProgress size={20} /> : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReplacementValueDeleteDialog;
